import {api} from '_api';
import type {Mutator} from '_types/swr';

import {unwrap} from '_utils/axios';
import {parseKey} from '_utils/swr';
import {NoContent} from "_types";
import type {User} from "_types/models/User";

export const uploadPhoto: Mutator<NoContent, {}> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.post<NoContent>(url, payload, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return await unwrap(response);
};


export const updateProfile: Mutator<NoContent, { name: string }> = async (queryKey, payload) => {
    const url = parseKey(queryKey);
    const response = await api.patch<NoContent>(url, payload);

    return await unwrap(response);
};
